module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400italic.woff2?bb915319f59c02c348a615ad483772e7";